import { Search, Plus, Trash2, Download } from 'lucide-react';
import { Button, Input } from '@/components/common';

interface UserListToolbarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedCount: number;
  onBulkDelete: () => void;
  onExport: () => void;
  onCreateNew: () => void;
}

export function UserListToolbar({
  searchQuery,
  onSearchChange,
  selectedCount,
  onBulkDelete,
  onExport,
  onCreateNew,
}: UserListToolbarProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      {/* Search */}
      <div className="w-full sm:w-96">
        <Input
          type="search"
          placeholder="Search users by name or email..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          leftIcon={<Search className="w-5 h-5" />}
        />
      </div>

      {/* Actions */}
      <div className="flex gap-2 w-full sm:w-auto">
        {selectedCount > 0 ? (
          <>
            <Button
              variant="danger"
              size="md"
              icon={<Trash2 className="w-4 h-4" />}
              onClick={onBulkDelete}
            >
              Delete ({selectedCount})
            </Button>
            <Button
              variant="ghost"
              size="md"
              icon={<Download className="w-4 h-4" />}
              onClick={onExport}
            >
              Export
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="outline"
              size="md"
              icon={<Download className="w-4 h-4" />}
              onClick={onExport}
            >
              Export
            </Button>
            <Button
              variant="primary"
              size="md"
              icon={<Plus className="w-4 h-4" />}
              onClick={onCreateNew}
            >
              Add User
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
